// extracted by mini-css-extract-plugin
module.exports = {"container":"QlcS1dtlTjxYFjmK2dQSc","groupsList":"_1ZLMUnlrNHtzWLS6hG6vKu"};